export default __webpack_public_path__ + "static/media/18.9522635b.mp3";